window.initFilters = function initFilters( markers, options ) {
	options = options || {};

	function findOne( haystack, arr ) {
		return arr.some( function( v ) {
			return haystack.indexOf( v ) >= 0;
		} );
	}

	function getActiveIds( filterGroups ) {
		var activeIds = [];
		for ( var markerIndex = 0; markerIndex < markers.length; markerIndex++ ) {
			var activeMarker = true;

			for ( var filterIndex = 0; filterIndex < filterGroups.length; filterIndex++ ) {
				var key = filterGroups[ filterIndex ].name;
				var values = filterGroups[ filterIndex ].values;

				if ( values.length > 0 ) {
					if ( !findOne( markers[ markerIndex ][ key ], values ) ) {
						activeMarker = false;
					}
				}
			}

			if ( activeMarker ) {
				activeIds.push( markers[ markerIndex ].id );
			}
		}
		return activeIds;
	}

	var getFilterGroups = function() {
		var filterGroups = [];
		$( '.filter-group' ).each( function( filterGroupIndex ) {
			filterGroups[ filterGroupIndex ] = {};
			filterGroups[ filterGroupIndex ].name = $( this ).attr( 'data-name' );
			filterGroups[ filterGroupIndex ].values = [];
			$( this ).find( 'input' ).each( function() {
				filterGroups[ filterGroupIndex ].values.push( $( this ).attr( 'value' ) );
			} );
		} );
		return filterGroups;
	};

	var getActiveFilterGroups = function() {
		var filterGroups = [];
		$( '.filter-group' ).each( function( filterGroupIndex ) {
			filterGroups[ filterGroupIndex ] = {};
			filterGroups[ filterGroupIndex ].name = $( this ).attr( 'data-name' );
			filterGroups[ filterGroupIndex ].values = [];
			$( this ).find( 'input:checked' ).each( function() {
				var value = $( this ).attr( 'value' );
				if ( value === undefined || value === null ) {
					return;
				}
				filterGroups[ filterGroupIndex ].values.push( $( this ).attr( 'value' ) );
			} );
		} );
		return filterGroups;
	};

	var getPossibleFilterGroups = function( activeFilterGroups ) {
		var possibleFilterGroups = [];

		getFilterGroups().forEach( function( filterGroup, filterGroupIndex ) {
			var currentPossibleFilterGroups = {
				name: filterGroup.name,
				values: [],
			};
			filterGroup.values.forEach( function( filter ) {
				var testFilterGroups = cloneFilterGroups( activeFilterGroups );
				testFilterGroups[ filterGroupIndex ].values = [];
				testFilterGroups[ filterGroupIndex ].values.push( filter );

				if ( getActiveIds( testFilterGroups ).length ) {
					currentPossibleFilterGroups.values.push( filter );
				}
			} );
			possibleFilterGroups.push( currentPossibleFilterGroups );
		} );

		return possibleFilterGroups;
	};

	function cloneFilterGroups( filterGroups ) {
		var clone = [];
		filterGroups.forEach( function( filterGroup ) {
			clone.push( {
				name: filterGroup.name,
				values: filterGroup.values.slice(),
			} );
		} );
		return clone;
	}

	$( '.filter-group input' ).on( 'click', function() {
		var $this = $( this );

		if ( $this.hasClass( 'reset' ) ) {
			$this.parents( '.filter-group' ).find( '.filter' )
				.removeClass( 'active' )
				.removeClass( 'inactive' )
				.find( 'label' ).removeClass( 'inactive' )
				.find( 'input' ).prop( 'checked', false ).prop( 'disabled', false );
		}
		updateFilters();

		$this.parents( '.filter-group' ).find( '.filter-group-title' ).html( $( this ).attr( 'data-title' ) );
		$this.parents( '.filter-group' ).find( '.filter-items-container' )
			.stop().slideUp( 'fast' )
			.attr( 'data-toggle-slide-direction', 'down' );
		$this.parents( '.filter-group' ).find( '.filter-group-arrow' )
			.removeClass( '-rotate-90' ).addClass( 'rotate-90' );
	} );

	$( '.filter-group .filter-group-toggle' ).on( 'click', function() {
		var $this = $( this );

		$( '.filter-items-container' ).stop().slideUp( 'fast' );
		$this.parents( '.filter-group' )
			.each( function() {
				var $this = $( this );
				var $filterItemsContainer = $this.find( '.filter-items-container' );
				var $filterGroupArrow = $this.find( '.filter-group-arrow' );
				if ( $filterItemsContainer.attr( 'data-toggle-slide-direction' ) === 'up' ) {
					$filterItemsContainer.attr( 'data-toggle-slide-direction', 'down' );
					$filterGroupArrow.removeClass( '-rotate-90' ).addClass( 'rotate-90' );
				} else {
					$filterItemsContainer.attr( 'data-toggle-slide-direction', 'up' );
					$filterGroupArrow.removeClass( 'rotate-90' ).addClass( '-rotate-90' );
				}
			} )
			.find( '.filter-items-container' ).stop().slideToggle( 'fast' );
	} );

	$( document ).click( function( event ) {
		if ( !$( event.target ).closest( '.filter-group' ).length ) {
			$( '.filter-items-container' )
				.stop().slideUp( 'fast' )
				.attr( 'data-toggle-slide-direction', 'down' );
			$( '.filter-group' ).find( '.filter-group-arrow' )
				.removeClass( '-rotate-90' ).addClass( 'rotate-90' );
		}
	} );

	var firstRun = true;

	function updateFilters() {
		var select = getActiveFilterGroups();
		$( '.filter[data-filter-type="filter"]' )
			.addClass( 'inactive' )
			.prop( 'disabled', true )
			.parent().addClass( 'inactive' );
		getPossibleFilterGroups( select ).forEach( function( filterGroup ) {
			var $filterGroup = $( '.filter-group[data-name="' + filterGroup.name + '"]' );
			filterGroup.values.forEach( function( filter ) {
				$filterGroup.find( '.filter[value="' + filter + '"]' )
					.removeClass( 'inactive' )
					.prop( 'disabled', false )
					.parent().removeClass( 'inactive' );
			} );
		} );

		if ( firstRun ) {
			firstRun = false;
			$( '.filter.inactive' ).parentsUntil( 'li' ).remove();
		}

		var activeIds = getActiveIds( select );
		$( '*[data-post-id]' ).each( function() {
			var $this = $( this );
			$this
				.removeClass( 'md:pt-32' )
				.removeClass( 'active' )
				.toggleClass( 'filtered', activeIds.indexOf( parseInt( $this.attr( 'data-post-id' ) ) ) < 0 );
		} )
			.not( '.filtered' ).eq( 1 ).addClass( 'md:pt-32' );
		resetLoadMore();
		// setTimeout( function() {
		// 	msnry.masonry();
		// 	setTimeout( function() {
		// 		animateInViewport();
		// 	}, 500 );
		// }, 0 );
	}

	updateFilters();
};
